import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {useShouldShowPrice} from "../../hooks/use_should_show_price";
import {useLeadFormSimplifiedAbTest} from "../../lead/hooks/use_lead_form_simplified_ab_test";
import {GTMEventApplicationSourceSection} from "../../lead/types/GTMEvenApplicationSourceSection";
import {getLeadButtonText} from "../../lead/utils/get_lead_button_text";
import {InquiryButtonTypeName} from "../../offer/detail/constants/inquiry_button_type";
import {getOfferDisplayStatus} from "../../offer/utils/get_offer_display_status";
import {IPropertyDetail} from "../types/IPropertyDetail";

interface IProps {
    property: IPropertyDetail;
}

export const PropertyDetailHeaderPrice = (props: IProps) => {
    const {property} = props;

    const {isFullOfferFormVariant} = useLeadFormSimplifiedAbTest();

    const shouldShowPrice = useShouldShowPrice({
        offerPriceVisibility: property.offer.configuration.price_visibility,
        vendorPriceVisibility: property.offer.vendor.configuration.price_visibility,
        vendorId: property.offer.vendor.id
    });

    const buttonText = getLeadButtonText({
        isPriceHidden: !shouldShowPrice,
        isProperty: !!property.id,
        propertyPrice: property.price,
        isFullOfferFormVariant
    });

    const showPrice = shouldShowPrice && !!property.price;
    const source = showPrice || (property.configuration.show_price && !!property.price) ? ApplicationSource.Property : ApplicationSource.PriceInquiry;

    const gtmData = {
        clickText: buttonText,
        source: GTMEventApplicationSourceSection.HEADER_LEAD,
        vendorName: property.offer.vendor.name ?? property.offer.vendor.id.toString(),
        offerName: property.offer.name ?? property.offer.id.toString()
    };

    return (
        <ApplicationModalButton
            source={source}
            sourceSection={ApplicationSourceSection.MODAL}
            vendorId={property.offer.vendor.id}
            offerId={property.offer.id}
            propertyId={property.id}
            forceClose={getOfferDisplayStatus(property.offer) === "limited"}
            render={({openModal}) => (
                <div className={priceButtonWrap}>
                    <Button
                        onClick={() => openModal(gtmData)}
                        variant="filled_primary"
                        className={showPrice || !property.price ? button : fullWidth}
                        dataTestId={buttonText === InquiryButtonTypeName.PRICE ? OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON : undefined}
                    >
                        {buttonText}
                    </Button>
                </div>
            )}
            currency={property?.offer.currency}
        />
    );
};

const priceButtonWrap = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1
});

const button = css({
    minWidth: "20rem"
});

const fullWidth = css({
    width: "100%",
    flexBasis: "100%"
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {useShouldShowPrice} from "../../hooks/use_should_show_price";
import {useLeadFormSimplifiedAbTest} from "../../lead/hooks/use_lead_form_simplified_ab_test";
import {GTMEventApplicationSourceSection} from "../../lead/types/GTMEvenApplicationSourceSection";
import {getLeadButtonText} from "../../lead/utils/get_lead_button_text";
import {InquiryButtonTypeName} from "../../offer/detail/constants/inquiry_button_type";
import {getOfferDisplayStatus} from "../../offer/utils/get_offer_display_status";
import {IPropertyDetail} from "../types/IPropertyDetail";

interface IProps {
    property: IPropertyDetail;
}

export const PropertyDetailHeaderPrice = (props: IProps) => {
    const {property} = props;

    const {isFullOfferFormVariant} = useLeadFormSimplifiedAbTest();

    const shouldShowPrice = useShouldShowPrice({
        offerPriceVisibility: property.offer.configuration.price_visibility,
        vendorPriceVisibility: property.offer.vendor.configuration.price_visibility,
        vendorId: property.offer.vendor.id
    });

    const buttonText = getLeadButtonText({
        isPriceHidden: !shouldShowPrice,
        isProperty: !!property.id,
        propertyPrice: property.price,
        isFullOfferFormVariant
    });

    const showPrice = shouldShowPrice && !!property.price;
    const source = showPrice || (property.configuration.show_price && !!property.price) ? ApplicationSource.Property : ApplicationSource.PriceInquiry;

    const gtmData = {
        clickText: buttonText,
        source: GTMEventApplicationSourceSection.HEADER_LEAD,
        vendorName: property.offer.vendor.name ?? property.offer.vendor.id.toString(),
        offerName: property.offer.name ?? property.offer.id.toString()
    };

    return (
        <ApplicationModalButton
            source={source}
            sourceSection={ApplicationSourceSection.MODAL}
            vendorId={property.offer.vendor.id}
            offerId={property.offer.id}
            propertyId={property.id}
            forceClose={getOfferDisplayStatus(property.offer) === "limited"}
            render={({openModal}) => (
                <div className={priceButtonWrap}>
                    <Button
                        onClick={() => openModal(gtmData)}
                        variant="filled_primary"
                        className={showPrice || !property.price ? button : fullWidth}
                        dataTestId={buttonText === InquiryButtonTypeName.PRICE ? OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON : undefined}
                    >
                        {buttonText}
                    </Button>
                </div>
            )}
            currency={property?.offer.currency}
        />
    );
};

const priceButtonWrap = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1
});

const button = css({
    minWidth: "20rem"
});

const fullWidth = css({
    width: "100%",
    flexBasis: "100%"
});
